import { HttpClient } from '#client/http/index'
import {
  MeResponse,
  MeUpdateParams,
  MeGradeNotificationsResponse,
  MeGradeHistoriesResponse,
} from '#client/resources/index'
import { depend } from '#client/utils/depend'
import { serialize } from 'object-to-formdata'

export const get = async ({ httpClient }: { httpClient: HttpClient }) => {
  const { data } = await httpClient.get<MeResponse>('/user/me')
  return data
}

export const update = depend(
  { transformParams: serialize },
  async (
    { transformParams },
    { httpClient }: { httpClient: HttpClient },
    params: MeUpdateParams,
  ) => {
    return await httpClient.post('/user/me', transformParams(params), {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-HTTP-Method-Override': 'PUT',
      },
    })
  },
)

export const getGradeNotification = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data } = await httpClient.get<MeGradeNotificationsResponse>(
    '/user/me/notifications',
  )
  return Array.isArray(data) ? null : data
}

export const markGradeNotificationAsRead = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  return await httpClient.put(`/user/me/notifications/markAsRead`)
}

export const listGradeHistories = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data } = await httpClient.get<MeGradeHistoriesResponse>(
    '/user/me/histories',
  )
  return data
}
